import styled from 'styled-components';
import H3 from '@sdk/components/ui/typography/H3';

import { CONVERSATION_LEFT_PADDING } from '@web/conversations/consts/layout';

const GAP = 20;

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 0 ${GAP}px ${GAP}px;
  position: relative;
`;

export const ListWrapper = styled.div`
  flex: 1;
  overflow: hidden;
  padding: 0 0 30px ${CONVERSATION_LEFT_PADDING}px;
`;

export const SearchHeader = styled.header`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
  display: flex;
  height: 75px;
  padding-left: ${CONVERSATION_LEFT_PADDING}px;
`;

export const QueryText = styled(H3)`
  display: inline;
`;
